'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setReturnSaga = setReturnSaga;

var _effects = require('redux-saga/effects');

var _reduceReturns = require('../../actions/workflow/reduceReturns');

var _reduceStep = require('../../actions/workflow/reduceStep');

var _selectReturns = require('../../selectors/workflow/selectReturns');

var _selectStep = require('../../selectors/workflow/selectStep');

var _reduceReturn = require('../../actions/workflow/reduceReturn');

var _reduceReturnElement = require('../../actions/workflow/reduceReturnElement');

var _reduceReturnDeep = require('../../actions/workflow/reduceReturnDeep');

var _validation = require('./validation');

var _visibility = require('./visibility');

var _reduceValid = require('../../actions/workflow/reduceValid');

var _selectDynamicDate = require('../../selectors/workflow/selectDynamicDate');

var _reduceTableReturn = require('../../actions/workflow/reduceTableReturn');

var _marked = /*#__PURE__*/regeneratorRuntime.mark(setReturnSaga);

function setReturnSaga(action) {
    var dynamicDate, returns, step;
    return regeneratorRuntime.wrap(function setReturnSaga$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    if (!action.payload.componentCode.includes('[0]')) {
                        _context.next = 5;
                        break;
                    }

                    _context.next = 3;
                    return (0, _effects.put)((0, _reduceTableReturn.reduceTableReturn)(action.payload));

                case 3:
                    _context.next = 17;
                    break;

                case 5:
                    if (!action.payload.code) {
                        _context.next = 15;
                        break;
                    }

                    if (!action.payload.code.includes('.')) {
                        _context.next = 11;
                        break;
                    }

                    _context.next = 9;
                    return (0, _effects.put)((0, _reduceReturnDeep.reduceReturnDeep)(action.payload));

                case 9:
                    _context.next = 13;
                    break;

                case 11:
                    _context.next = 13;
                    return (0, _effects.put)((0, _reduceReturnElement.reduceReturnElement)(action.payload));

                case 13:
                    _context.next = 17;
                    break;

                case 15:
                    _context.next = 17;
                    return (0, _effects.put)((0, _reduceReturn.reduceReturn)(action.payload));

                case 17:
                    _context.next = 19;
                    return (0, _effects.select)((0, _selectDynamicDate.selectDynamicDate)());

                case 19:
                    dynamicDate = _context.sent;
                    _context.next = 22;
                    return (0, _effects.select)((0, _selectReturns.selectReturns)());

                case 22:
                    returns = _context.sent;
                    _context.next = 25;
                    return (0, _effects.select)((0, _selectStep.selectStep)());

                case 25:
                    step = _context.sent;

                    step = (0, _visibility.setStepVisibility)(step, returns);
                    returns = (0, _visibility.getStepVisibility)(step, returns);
                    step = (0, _validation.setStepValidation)(step, returns, dynamicDate);
                    _context.next = 31;
                    return (0, _effects.put)((0, _reduceStep.reduceStep)(step));

                case 31:
                    _context.next = 33;
                    return (0, _effects.put)((0, _reduceReturns.reduceReturns)(returns));

                case 33:
                    _context.next = 35;
                    return (0, _effects.put)((0, _reduceValid.reduceValid)((0, _validation.getStepValidation)(step)));

                case 35:
                    return _context.abrupt('return');

                case 36:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}